const constants = require('@/util/constants')
require('./config')

/**
 * 获取全部快捷回复
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getCuws(successcb, failedcb) {
  axios.get('/api/cuw/get', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取公司类型快捷回复
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function getCompanyCuws(successcb, failedcb) {
//   axios.get('/api/cuw/company', {
//     params: {
//       'client': constants.HTTP_CLIENT
//     }
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 获取子快捷回复
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function getChildrenCuws (pid, successcb, failedcb) {
//   axios.get('/api/cuw/children', {
//     params: {
//       'pid': pid,
//       'client': constants.HTTP_CLIENT
//     }
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 创建快捷回复
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function cuwCreate(categoryId, name, type, content, choices, richtext, published, shortcut, successcb, failedcb) {
  axios.post('/api/cuw/create', {
    categoryId,
    name,
    type,
    content,
    choices,
    richtext,
    published,
    shortcut,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新快捷回复
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function cuwUpdate(id, name, type, content, choices, richtext, published, shortcut, successcb, failedcb) {
  axios.post('/api/cuw/update', {
    id,
    name,
    type,
    content,
    choices,
    richtext,
    published,
    shortcut,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除快捷回复
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function cuwDelete(id, successcb, failedcb) {
  axios.post('/api/cuw/delete', {
    id: id,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
